
import React, { useEffect, useState } from 'react';
import { api_bd_nr } from '../../services/Api.js';

const ConfigChart = (props) => {
    const [listUsers, setListUsers] = useState([]);
    const [listParticipants, setlistParticipants] = useState(props.participantsList || []);
    const baseImgUrl = 'https://apisgi.intecsolutions.com.br/files/'

    // console.log('props.participantsList', props.participantsList)

    const handleParticipants = (operation, participant) => {
        // console.log('handleParticipants', operation, typeof operation, participant)
        if (operation) {
            setlistParticipants(current => {
                return [...current, participant]
            })
        } else {
            setlistParticipants(current => {
                return current.filter(el => {
                    // console.log(el, participant)
                    return ((el._id !== participant._id) && (el.id !== participant._id))
                })
            })
        }
    }

    const loadData = () =>{
        api_bd_nr.get('/performance-radar', {
            params: {
                q: 'listusers',
            }
        })
            .then(resp => {
                const users = resp.data.map(({ _id, nome, image_profile }) => ({ _id, nome, image_profile: baseImgUrl + image_profile.filename }))
                setListUsers(users)
            })
            .catch(e => {
                console.log(e)
            })
    }

    useEffect(() => {
        loadData()
    }, [])

    useEffect(() => {
        // console.log('listParticipants', listParticipants)
        if (props.onChangeParticipantList) {
            props.onChangeParticipantList(listParticipants)
        }
    }, [listParticipants])

    return (
        <div
            className='duration-300 ease-in-out w-[400px] md:min-w-[600px]'
            style={{
                maxHeight: '80dvh',
                padding: 10,
                zIndex: 9999
                // transition: 'all 1.5s linear'
            }}
        >
            <h2 className='font-bold'>Configurações</h2>
            {listUsers.length === 0 ?
                (<span>Carregando lista...</span>) :
                (<>
                    <p>Aqui você seleciona os participantes do gráfico</p>
                    <div style={{ paddingTop: 10, overflowY: 'auto', maxHeight: '60dvh', marginBottom: 10 }}>
                        {
                            listUsers.sort(function (a, b) {
                                if (a.nome < b.nome) {
                                  return -1;
                                }
                                if (a.nome > b.nome) {
                                  return 1;
                                }
                                return 0;
                              }).map(user => (
                                <div
                                    className='bg-blue-900 rounded text-white hover:bg-blue-800'
                                    key={user._id} style={{ padding: 10, display: 'flex', alignItems: 'center', gap: 10, marginBottom: 5 }}
                                >
                                    <input
                                        className='accent-green-500'
                                        type="checkbox"
                                        checked={listParticipants.find(el => (el.id === user._id) || (el._id === user._id)) ? true : false}
                                        style={{ transform: 'scale(1.5)' }}
                                        onChange={(e) => {
                                            handleParticipants(e.target.checked, user)
                                        }}
                                    />
                                    <img style={{ width: 50, height: 50, objectFit: 'cover', borderRadius: "100%" }} src={user.image_profile} alt={user.nome} />
                                    <span className='font-light text-sm'>{user.nome}</span>
                                </div>
                            ))
                        }
                    </div>
                    <button
                        className='py-2 px-4 rounded bg-blue-900 hover:bg-blue-800 active:hover:bg-blue-900 text-white font-bold cursor-pointer'
                        onClick={() => {
                            if (props.onSaveButtonClick) {
                                props.onSaveButtonClick(listParticipants, props.selectedMonth)
                            }
                        }}
                    >Salvar</button>
                </>)
            }
        </div >
    );
};

export default ConfigChart